<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header">Recherche référentiels</div>

        <div class="modal-body">
            <form [formGroup]="formGroup" class="form-card-content" (ngSubmit)="onSubmit()" *ngIf="formGroup">
                <frg-form-input
                    label="Références / Terminologies"
                    id="selectedRef"
                    type="ngSelect"
                    [formGroup]="formGroup"
                    [control]="formGroup.get('selectedRef')"
                    (modelChanged)="search()"
                    [selectValue]="getEnableRefs"
                    required="true"
                    [isClearableSelect]="false">
                </frg-form-input>

                <frg-form-input
                    label="Recherche"
                    id="search"
                    type="text"
                    [formGroup]="formGroup"
                    [control]="formGroup.get('search')"
                    (modelChanged)="search()"
                    required="true"
                    [appAutoFocus]="true">
                </frg-form-input>

                <div class="result-wrapper">
                    <div class="result-title">Résultat</div>
                    <div class="result-result-wrapper">
                        <ng-container *ngIf="searchResult && searchResult.length > 0">
                            <div class="result" *ngFor="let result of searchResult" [ngClass]="{ 'hover': selectedResult && selectedResult.id === result.id }">
                                <span (click)="selectResult(result)">{{ result.libelle }}</span>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="(!searchResult || searchResult.length === 0) && (formGroup.get('search') && formGroup.get('search').value && formGroup.get('search').value !== '' && formGroup.get('search').value.length >= 3)">
                            <div class="result">
                                <span>Aucun résultat</span>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="(!searchResult || searchResult.length === 0) && (!formGroup.get('search') || !formGroup.get('search').value || formGroup.get('search').value.length < 3)">
                            <div class="result">
                                <span>Commencez en saisissant votre recherche (à partir de 3 caractères)</span>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- <div class="result-wrapper" *ngIf="!searchResult || searchResult.length === 0">
                    <div class="result-result-wrapper">
                        <ng-container *ngIf="formGroup.get('search') && formGroup.get('search').value && formGroup.get('search').value !== ''">
                            <div class="result">
                                <span>Aucun résultat</span>
                            </div>
                        </ng-container>
                    </div>
                </div> -->

                <div class="error-message-container" *ngIf="error">
                    <div>
                        <div class="error-message">{{error}}</div>
                    </div>
                </div>

                <div class="button-wrapper"> 
                    <frg-button (activated)="closeModal()" [backgroundColor]="'var(--darkest-primary)'"
                        [type]="'reset'">Quitter</frg-button>
                    <frg-button [type]="'submit'" [backgroundColor]="'var(--primary)'" [disabled]="!selectedResult">Valider
                    </frg-button>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal-background"></div>